import { ISubSystemActionTypes, eSubSystemActionTypeIds } from "../../action-types/sub-sytem/ISubSytemActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ISubSystemReducer } from "../../reducer-model/sub-sytem/ISubSytemReducer";
const iniState: ISubSystemReducer = {
    status: eReducerStatusBase.is_not_initialization,
    sub_systems: []
}
export const subSystemReducer = (state: ISubSystemReducer = iniState, action: ISubSystemActionTypes): ISubSystemReducer => {
    switch (action.type) {
        case eSubSystemActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eSubSystemActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                sub_systems: action.payload
            }
        case eSubSystemActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                sub_systems: []
            }

        default:
            return { ...state }
    }
}